import { Link, isRouteErrorResponse, useRouteError } from 'react-router';

export function NotFoundPage() {
  return (
    <article>
      <h1>Not found</h1>
      <p className="lede">
        We couldn't find the page you were after. The link might be old, mistyped, or the sweepstake might have been archived.
      </p>
      <p style={{ marginTop: 16 }}>
        <Link className="btn btn-primary" to="/">
          Back to the homepage
        </Link>
      </p>
    </article>
  );
}

export function RouteErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFoundPage />;
  }

  const message =
    isRouteErrorResponse(error)
      ? `${error.status} ${error.statusText}`
      : error instanceof Error
      ? error.message
      : 'Something went wrong.';

  return (
    <article>
      <h1>Something went wrong</h1>
      <p className="lede">
        We hit an unexpected error rendering this page. The error is below if you'd like to copy it into a bug report.
      </p>
      <p className="muted" style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 14 }}>
        {message}
      </p>
      <p style={{ marginTop: 16 }}>
        <Link className="btn btn-primary" to="/">
          Back to the homepage
        </Link>
      </p>
    </article>
  );
}
